import type { InstanceStore } from '../store/schema/TaskModuleInstances';
import { taskModules } from '../store/taskModule';

export default (id: string): InstanceStore | undefined => taskModules().instances.get(id);
